import {blockTemplate} from './block';
import {paragraphTemplate} from './paragraph';
import {titleTemplate} from './title';

export const simpleBlockTemplate = {
  '_template': 'simple',
  ...blockTemplate,
  blocks: [
    titleTemplate,
    paragraphTemplate
  ]
};
